import React from "react";

import Journey from "./Journey";

const Index = (props) => {
  return (<Journey {...props}/>);
};

export default Index;